import { render } from "./DriveRedirectView.vue?vue&type=template&id=22c0ba06"
import script from "./DriveRedirectView.vue?vue&type=script&lang=js"
export * from "./DriveRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__